import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { CheckCircle2, AlertTriangle, Info } from 'lucide-react';
import { Alert, AlertDescription } from './ui/alert';

interface UpdateLeadStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (status: 'completed' | 'dispute',) => void;
  leadTitle: string;
}

export function UpdateLeadStatusModal({
  isOpen,
  onClose,
  onConfirm,
  leadTitle,
}: UpdateLeadStatusModalProps) {
  const [status, setStatus] = useState<'completed' | 'dispute'>('completed');
  const [notes, setNotes] = useState('');

  const handleConfirm = () => {
    onConfirm(status);
    setStatus('completed');
  };

  const handleCancel = () => {
    onClose();
    setNotes('');
    setStatus('completed');
  };

  return (
    <Dialog  open={isOpen} onOpenChange={handleCancel}>
      <DialogContent className="lead-status-dialog tailwind-prefix h-[200px] sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Update Lead Status</DialogTitle>
          <DialogDescription>
            Update the status for "{leadTitle}"
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 ">
          <div className="space-y-3">
            <Label>Select Status</Label>
            <RadioGroup value={status} onValueChange={(value) => setStatus(value as 'completed' | 'dispute')}>
              <div className="flex items-center space-x-3 p-4 border rounded-lg hover:bg-gray-50 cursor-pointer transition-colors">
                <RadioGroupItem value="completed" id="completed" />
                <div className="flex-1">
                  <label
                    htmlFor="completed"
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    
                    <div>
                      <div className="font-medium">Mark as Completed <CheckCircle2 className="size-5 ml-1 text-green-600" /></div>
                      <div className="text-sm text-muted-foreground">
                        Project finished successfully
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              <div className="flex items-center space-x-3 p-4 border rounded-lg hover:bg-gray-50 cursor-pointer transition-colors">
                <RadioGroupItem value="dispute" id="dispute" />
                <div className="flex-1">
                  <label
                    htmlFor="dispute"
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    <div>

                      <div className="font-medium">Report Dispute                     <AlertTriangle className="size-5 ml-1 text-orange-600" /></div>
                      <div className="text-sm text-muted-foreground">
                        There's an issue with this project
                      </div>
                      
                    </div>
                  </label>
                </div>
              </div>
            </RadioGroup>
          </div>

         

          {/* {status === 'dispute' && (
            <Alert>
              <Info className="size-4" />
              <AlertDescription>
                Our support team will review your dispute and contact both parties within 24 hours.
              </AlertDescription>
            </Alert>
          )} */}

          {/* {status === 'completed' && (
            <Alert>
              <CheckCircle2 className="size-4" />
              <AlertDescription>
                Once marked as completed, the platform fee will be processed and you'll receive payment within 3-5 business days.
              </AlertDescription>
            </Alert>
          )} */}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button 
            onClick={handleConfirm}
          >
            {status === 'completed' ? 'Mark as Completed' : 'Submit Dispute'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
